import React from 'react';
import "./ForInfluencersRole.scss";
import {RoleCards} from "./content/CardContent";
import { Image } from "antd";
import Icon from "@ant-design/icons";
import { ReactComponent as ImagePlaceholder } from "assets/icons/image-placeholder.svg";

export const ForInfluencersRole: React.FC = React.memo(() => {
    return (
        <div className="for-influencers-role">
            <div className="gradient-block"/>
            <div className="role-block">
                <div className="role-block-header">
                    <p className="title">YOUR ROLE IN MIUT <br/> (Player Archetypes)</p>
                    <p className="subtitle">"In Miut, everyone finds their prey. Some seek glory, some seek crypto, and some just want a reason to scream obscenities in voice chat. Who are you?"</p>
                </div>
                <div className="content">
                    {RoleCards.map((card) => (
                        <div className="card">
                            <div className="card-image">
                                <Image
                                    src={card.image_preview}
                                    preview={{
                                        src: card.image,
                                        mask: (
                                            <Icon
                                                component={ImagePlaceholder}
                                                style={{ fontSize: "4rem" }}
                                            />
                                        ),
                                    }}
                                />
                            </div>
                            <div className="card-content">
                                <div className="card-title">
                                    {card.title}
                                </div>
                                <div className="card-description">
                                    {card.description}
                                </div>
                                <div className="card-hint">
                                    {card.hint}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
});